import React from 'react'
import { useTranslation } from 'react-i18next'
import NoAttentionRequiredIcon from '../../icons/NoAttentionRequiredIcon'
import BaseWidget from '../../components/common/BaseWidget'
import NumberWidget from '../../components/common/NumberWidget/NumberWidget'

const NoAttentionRequired = ({ value, isLoading }) => {
  const { t } = useTranslation()

  return (
    <BaseWidget carousel={false}>
      <NumberWidget
        isLoading={isLoading}
        key={'noAttentionRequired'}
        label={t('pages.copilotControl.widgets.noAttentionRequired.title')}
        icon={NoAttentionRequiredIcon}
        value={value}
        tooltipText={t('pages.copilotControl.widgets.noAttentionRequired.tooltip')}
      />
    </BaseWidget>
  )
}

export default NoAttentionRequired
